module.exports = __webpack_public_path__ + "img/IMG_3878.1b1d6b9c.jpg";